import { API } from '@canvas-logic/clp-viewer3d';

const AR_VIEWER_URL = window.APP_CONFIG.AR_VIEWER_URL;

export class WebArService {
  constructor(private readonly api: API) {}

  async generateArLink(projectId: string): Promise<string> {
    const [gltfId] = await Promise.all([
      this.generateArLinkGLTF(projectId),
      // this.generateArLinkUSDZ()
    ]);
    // const url = `${AR_VIEWER_URL}?gltfId=${gltfId}&project=${AR_PROJECT}`;
    const url = `${AR_VIEWER_URL}/link/${gltfId}?project=${projectId}`;
    return url;
  }

  private async generateArLinkGLTF(projectId: string): Promise<string> {
    const glb = await this.api.exportGltfScene();
    const url = `${AR_VIEWER_URL}?project=${projectId}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      body: glb,
    });
    const data = await response.json();
    return data.id;
  }
}
